import React from 'react';

export type BadgeTone =
  | 'sand'
  | 'sage'
  | 'terracotta'
  | 'amber'
  | 'red'
  | 'blue';

interface BadgeProps {
  tone?: BadgeTone;
  children: React.ReactNode;
  className?: string;
  uppercase?: boolean;
}

const toneClass: Record<BadgeTone, string> = {
  sand: 'bg-sand-100 text-sand-700',
  sage: 'bg-sage-50 text-sage-800',
  terracotta: 'bg-terracotta-50 text-terracotta-700',
  amber: 'bg-amber-50 text-amber-800',
  red: 'bg-red-50 text-red-700',
  blue: 'bg-sky-50 text-sky-700',
};

export const Badge: React.FC<BadgeProps> = ({
  tone = 'sand',
  children,
  className = '',
  uppercase,
}) => (
  <span
    className={[
      'inline-flex items-center px-2.5 py-0.5 text-[11px] font-medium rounded-full',
      uppercase ? 'uppercase tracking-wide' : '',
      toneClass[tone],
      className,
    ].join(' ')}
  >
    {children}
  </span>
);

export const loyaltyTone = (
  status: 'Gold' | 'Silver' | 'Bronze' | 'New'
): BadgeTone => {
  switch (status) {
    case 'Gold':
      return 'amber';
    case 'Silver':
      return 'sand';
    case 'Bronze':
      return 'terracotta';
    case 'New':
    default:
      return 'sage';
  }
};
